class StickyAddToCart {
  constructor() {
    this.elements = this._getElements();
    if (!this.elements.stickyCart) return;

    this.isVisible = false;
    this.productForm = null;
    this.originalAddToCartBtn = null;

    this._init();
  }

  _getElements() {
    return {
      stickyCart: document.querySelector("[data-sticky-cart]"),
      stickyAddToCartBtn: document.querySelector("[data-sticky-add-to-cart]"),
      stickyVariantSelect: document.querySelector(
        "[data-sticky-variant-select]"
      ),
      stickyQuantity: document.querySelector("[data-sticky-quantity]"),
      stickyPrice: document.querySelector("[data-sticky-price]"),
      quantityMinus: document.querySelector("[data-quantity-minus]"),
      quantityPlus: document.querySelector("[data-quantity-plus]"),
      productSection: document.querySelector(".product-v2"),
      originalForm: document.querySelector('form[action*="/cart/add"]'),
      soldOutLink: document.querySelector("[data-sold-out-link]"),
    };
  }

  _init() {
    this._setupEventListeners();
    this._syncWithOriginalForm();
  }

  _setupEventListeners() {
    // Scroll event to show/hide sticky cart
    window.addEventListener("scroll", this._handleScroll.bind(this));

    // Sticky cart interactions
    if (this.elements.stickyAddToCartBtn) {
      this.elements.stickyAddToCartBtn.addEventListener(
        "click",
        this._handleAddToCart.bind(this)
      );
    }

    if (this.elements.stickyVariantSelect) {
      this.elements.stickyVariantSelect.addEventListener(
        "change",
        this._handleVariantChange.bind(this)
      );
    }

    if (this.elements.quantityMinus) {
      this.elements.quantityMinus.addEventListener(
        "click",
        this._decreaseQuantity.bind(this)
      );
    }

    if (this.elements.quantityPlus) {
      this.elements.quantityPlus.addEventListener(
        "click",
        this._increaseQuantity.bind(this)
      );
    }

    if (this.elements.stickyQuantity) {
      this.elements.stickyQuantity.addEventListener(
        "change",
        this._handleQuantityChange.bind(this)
      );
    }

    if (this.elements.soldOutLink) {
      this.elements.soldOutLink.addEventListener(
        "click",
        this._scrollToForm.bind(this)
      );
    }

    // Listen for changes in the original form
    if (this.elements.originalForm) {
      const originalVariantRadios = this.elements.originalForm.querySelectorAll(
        'input[name="id"][type="radio"]'
      );
      const originalQuantityInput = this.elements.originalForm.querySelector(
        'input[name="quantity"]'
      );

      /*
      if (originalVariantRadios.length > 0) {
        originalVariantRadios.forEach((radio) => {
          radio.addEventListener(
            "change",
            this._syncFromOriginalForm.bind(this)
          );
        });
      }*/

      /*
      if (originalQuantityInput) {
        originalQuantityInput.addEventListener(
          "change",
          this._syncFromOriginalForm.bind(this)
        );
      }
      */
    }
  }

  _scrollToForm(event) {
    event.preventDefault();
    const form = document.querySelector(".product-v2--info.product-info-v2");
    if (form) {
      form.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }

  _handleScroll() {
    if (!this.elements.productSection) return;

    const productSectionBottom =
      this.elements.productSection.offsetTop +
      this.elements.productSection.offsetHeight;
    const scrollPosition = window.pageYOffset + window.innerHeight;

    const shouldShow = scrollPosition > productSectionBottom + 100;

    if (shouldShow && !this.isVisible) {
      this._showStickyCart();
    } else if (!shouldShow && this.isVisible) {
      this._hideStickyCart();
    }
  }

  _showStickyCart() {
    this.isVisible = true;
    this.elements.stickyCart.classList.add("is-visible");

    const smileUi = document.querySelector(
      "#smile-ui-lite-launcher-frame-container"
    );

    if (smileUi) {
      console.log("move");
      smileUi.classList.add("smile-ui-move-up");
    }
  }

  _hideStickyCart() {
    this.isVisible = false;
    this.elements.stickyCart.classList.remove("is-visible");

    const smileUi = document.querySelector(
      "#smile-ui-lite-launcher-frame-container"
    );

    if (smileUi) {
      console.log("restore");
      smileUi.classList.remove("smile-ui-move-up");
    }
  }

  _handleAddToCart() {
    const formData = this._getFormData();

    // Trigger the original form submission or use your existing cart functionality
    if (this.elements.originalForm) {
      // Update original form with sticky cart values
      this._updateOriginalForm(formData);

      // Trigger original form submission
      const originalSubmitBtn = this.elements.originalForm.querySelector(
        'button[type="submit"]'
      );
      if (originalSubmitBtn) {
        originalSubmitBtn.click();
      }
    } else {
      // Fallback: submit directly to cart
      this._submitToCart(formData);
    }
  }

  _getFormData() {
    const variantId = this.elements.stickyVariantSelect
      ? this.elements.stickyVariantSelect.value
      : this.elements.originalForm?.querySelector(
          'input[name="id"][type="radio"]:checked'
        )?.value;

    const quantity = this.elements.stickyQuantity.value || 1;

    return {
      id: variantId,
      quantity: parseInt(quantity),
    };
  }

  _updateOriginalForm(formData) {
    if (!this.elements.originalForm) return;

    const variantRadios = this.elements.originalForm.querySelectorAll(
      'input[name="id"][type="radio"]'
    );
    const quantityInput = this.elements.originalForm.querySelector(
      'input[name="quantity"]'
    );

    if (variantRadios.length > 0 && formData.id) {
      // Uncheck all radio buttons first
      variantRadios.forEach((radio) => {
        radio.checked = false;
      });

      // Check the selected variant
      const targetRadio = this.elements.originalForm.querySelector(
        `input[name="id"][type="radio"][value="${formData.id}"]`
      );
      if (targetRadio) {
        targetRadio.checked = true;
        targetRadio.dispatchEvent(new Event("change"));
      }
    }

    if (quantityInput) {
      quantityInput.value = formData.quantity;
      quantityInput.dispatchEvent(new Event("change"));
    }
  }

  async _submitToCart(formData) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        // Trigger cart update event or refresh cart drawer
        document.dispatchEvent(new CustomEvent("cart:updated"));
      } else {
        console.error("Failed to add to cart");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  }

  _handleVariantChange() {
    const selectedOption = this.elements.stickyVariantSelect.selectedOptions[0];
    const price = selectedOption.dataset.price;
    const comparePrice = selectedOption.dataset.comparePrice;

    this._updatePrice(price, comparePrice);
    this._syncToOriginalForm();
  }

  _updatePrice(price, comparePrice) {
    if (!this.elements.stickyPrice) return;

    const formattedPrice = window.formatMoney
      ? window.formatMoney(price)
      : `$${(price / 100).toFixed(2)}`;
    const formattedComparePrice =
      comparePrice && comparePrice > price
        ? window.formatMoney
          ? window.formatMoney(comparePrice)
          : `$${(comparePrice / 100).toFixed(2)}`
        : null;

    let priceHTML = `<span class="sticky-add-to-cart__current-price">${formattedPrice}</span>`;

    if (formattedComparePrice) {
      priceHTML =
        `<span class="sticky-add-to-cart__compare-price">${formattedComparePrice}</span>` +
        priceHTML;
    }

    this.elements.stickyPrice.innerHTML = priceHTML;
  }

  _decreaseQuantity() {
    const currentValue = parseInt(this.elements.stickyQuantity.value) || 1;
    if (currentValue > 1) {
      this.elements.stickyQuantity.value = currentValue - 1;
      this._syncToOriginalForm();
    }
  }

  _increaseQuantity() {
    const currentValue = parseInt(this.elements.stickyQuantity.value) || 1;
    this.elements.stickyQuantity.value = currentValue + 1;
    this._syncToOriginalForm();
  }

  _handleQuantityChange() {
    const value = parseInt(this.elements.stickyQuantity.value);
    if (value < 1) {
      this.elements.stickyQuantity.value = 1;
    }
    this._syncToOriginalForm();
  }

  _syncWithOriginalForm() {
    this._syncFromOriginalForm();
  }

  _syncFromOriginalForm() {
    if (!this.elements.originalForm) return;

    const originalVariantRadios = this.elements.originalForm.querySelectorAll(
      'input[name="id"][type="radio"]'
    );
    const originalQuantityInput = this.elements.originalForm.querySelector(
      'input[name="quantity"]'
    );

    if (originalVariantRadios.length > 0 && this.elements.stickyVariantSelect) {
      const checkedRadio = this.elements.originalForm.querySelector(
        'input[name="id"][type="radio"]:checked'
      );
      if (checkedRadio) {
        this.elements.stickyVariantSelect.value = checkedRadio.value;
        this._handleVariantChange();
      }
    }

    if (originalQuantityInput && this.elements.stickyQuantity) {
      this.elements.stickyQuantity.value = originalQuantityInput.value || 1;
    }
  }

  _syncToOriginalForm() {
    if (!this.elements.originalForm) return;

    const originalVariantRadios = this.elements.originalForm.querySelectorAll(
      'input[name="id"][type="radio"]'
    );
    const originalQuantityInput = this.elements.originalForm.querySelector(
      'input[name="quantity"]'
    );

    if (originalVariantRadios.length > 0 && this.elements.stickyVariantSelect) {
      // Uncheck all radio buttons first
      originalVariantRadios.forEach((radio) => {
        radio.checked = false;
      });

      // Check the selected variant
      const targetRadio = this.elements.originalForm.querySelector(
        `input[name="id"][type="radio"][value="${this.elements.stickyVariantSelect.value}"]`
      );
      if (targetRadio) {
        targetRadio.checked = true;
        targetRadio.dispatchEvent(new Event("change"));
      }
    }

    if (originalQuantityInput && this.elements.stickyQuantity) {
      originalQuantityInput.value = this.elements.stickyQuantity.value;
      originalQuantityInput.dispatchEvent(new Event("change"));
    }
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  new StickyAddToCart();
});
